<template>
  <div class="istatistics_customer">
    <div class="toolbar">
      <div class="info-header">
        <div class="title">{{companyInfo.companyName}}</div>
        <div class="add">详细地址：{{companyInfo.companyAddress}}</div>
        <div class="time">注册时间：{{companyInfo.registerTime}}</div>
        <div>
          <el-button plain @click="goto('devinfo')">开发者信息</el-button>
          <el-button plain @click="goto('interfacemanage')" v-if="![6, 7].includes(devStatus)">接口管理</el-button>
          <el-button type="primary" v-if="![6, 7].includes(devStatus)">调用统计</el-button>
        </div>
        <div class="user">
          <img v-if="devStatus == '2'" src="../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
          <img v-if="devStatus == '1'" src="../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
          <img v-if="devStatus == '3'" src="../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
          <img v-if="devStatus == '0'" src="../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787;">未生效用户</span>
          <img v-if="devStatus == '4'" src="../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
          <img v-if="devStatus == '5'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
          <img v-if="devStatus == '6'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '6'" style="color:#878787;">待审核</span>
          <img v-if="devStatus == '7'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '7'" style="color:#ed4a3a;">审核拒绝</span>
        </div>
        <div style="margin-top:10px;">
          <span style="font-size:14px;font-weight:bold;margin-right:20px;">调用统计</span>
          <el-date-picker
            style="width: 400px;"
            v-model="selectDate"
            type="daterange"
            align="right"
            unlink-panels
            :clearable="false"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="loadTableData"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="content_wrapper" >
      <el-table
            :data="tableData"
            header-row-class-name="header-row-class-name"
            border
            v-loading="loading"
            style="width: 100%">

            <el-table-column
              label="接口名称"
              align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="资源类型"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.resourceType === 0">/</div>
                <div v-if="scope.row.apiResourceDto.resourceType === 1">普通</div>
                <div v-if="scope.row.apiResourceDto.resourceType === 2">精品</div>
              </template>
            </el-table-column> -->

            <!-- <el-table-column
              label="可用上限"
              align="center"
              prop="invokeLimit">
            </el-table-column>

            <el-table-column
              label="下载上限"
              align="center"
              prop="invokeCount">
            </el-table-column> -->

            <el-table-column
              label="去重下载"
              align="center"
              prop="downloadCount">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="累计下载"
              align="center"
              prop="totalDownloadCount">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.totalDownloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="接口总调用量"
              align="center"
              prop="invokeCount">
            </el-table-column>

          </el-table>
    </div>
  </div>
</template>
<script type="text/babel">
import statisticsService from '@/service/statisticsService'
import devService from '@/service/devService'
import sysconstant from '@/utils/sysconstant'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      selectDate: [],
      tableData: [],
      loading: false,
      devStatus: '',
      type: '1'
    }
  },
  async mounted () {
    let toDate = new Date().Format(this.SysConstant.DATE_FORMATE)
    let fromDate = this.companyInfo.openingTime || (this.companyInfo.registerTime && this.companyInfo.registerTime.substr(0, 10)) || this.$util.getLast(-6)
    this.selectDate = [fromDate, toDate]
    await this.loadTableData()
    this.getDeveloperStatus()
  },
  computed: {
    ...mapGetters(['companyInfo'])
  },
  methods: {
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.companyInfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 续费开通
    gotoOpenRenew () {
      this.$router.push({name: 'openAndRenew', query: {id: this.companyInfo.id}})
    },
    async loadTableData () {
      this.loading = true
      let params = {
        id: this.companyInfo.id,
        companyName: this.companyInfo.companyName,
        fromDate: this.selectDate[0],
        toDate: this.selectDate[1]
      }
      try {
        let data = await statisticsService.fetchDevDetailData(params)
        let sortArr = ['通用', '文档', '试卷', '试题', '微课'];
        data = data.map(item => {
          return {
            ...item,
            order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
          }
        })
        if (data) {
          this.tableData = data.sort((a, b) => {
            return a.order - b.order
          })
        } else {
          this.tableData = []
        }
        this.loading = false
      } catch (e) {
        this.$message.error(e && e.msg)
        this.loading = false
      }
    },
    // 跳转页面
    goto (name) {
      this.$router.push({name: name})
    }
  }
}
</script>
<style scoped>
  .istatistics_customer {
    padding: 10px 0 0 0 ;
  }
  .istatistics_customer .toolbar{
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
    background-color: #ffffff;
  }

  .istatistics_customer .toolbar .info-header{
    background: #ffffff;
    padding: 20px 24px;
    position: relative;
    color: #333;
  }
  .istatistics_customer .toolbar .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .istatistics_customer .toolbar .info-header .add,.istatistics_customer .toolbar .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .istatistics_customer .toolbar .info-header .user span{
    position: absolute;
    right: 162px;
    top: 85px;
    font-size: 18px;
    font-weight: bold;
  }
  .istatistics_customer .toolbar .info-header .user img{
    position: absolute;
    right: 244px;
    top: 80px;
  }
  .istatistics_customer .toolbar .el-select {
    width: 130px;
  }
  .istatistics_customer .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .istatistics_customer .content_wrapper{
    background-color: #ffffff;
    padding:30px 10px 30px 20px;
  }

  .istatistics_customer .toolbar .el-select {
    width: 130px;
  }
  .istatistics_customer .toolbar .input-with-select{
    width: 400px;
  }
  .istatistics_customer .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;

  }
  .istatistics_customer .content_wrapper{
    background-color: #ffffff;
  }
</style>
<style type="text/css">
  .istatistics_customer .toolbar .el-input-group__append{
    background-color: #00AAFF;
    border: 1px solid #00AAFF;
    color: #ffffff;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/istatistics/customer.vue